import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ShieldCheckIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M11.96 21.36C7.98 20.14 4.32 16.48 4.32 13.14V6.54L11.96 3.18L19.6 6.54V13.14C19.6 16.48 15.94 20.14 11.96 21.36ZM6.16 12.98C6.16 15.6 9.1 18.46 11.96 19.4C14.82 18.46 17.76 15.6 17.76 12.98V7.72L11.96 5.2L6.16 7.72V12.98ZM7.82 12.12L8.98 10.98L11.04 13.04L15.22 8.86L16.38 10.02L11.04 15.36L7.82 12.12Z" />
    </SvgIcon>
  );
});
